import { addFilterSetting, getFilterSettingListByGame } from '@op/services';

export default function useHistoryFilter({ gameInfo }: { gameInfo: any }) {
  function selectCompetitorFilter() {
    if (!gameInfo) return null;
    return getFilterSettingListByGame({
      uid: gameInfo.edition_unified_id,
      uid_type: gameInfo.id_type,
      top_n: 1,
      business_type: 2,
    })
      .then((data: any) => {
        let filter = {};
        try {
          filter = JSON.parse(data?.[0]?.filter_info);
        } catch (error) {
          filter = {};
        }
        return filter;
      })
      .catch((error:any) => {
        console.log(error);
        return {};
      });
  }

  async function addCompetitorFilter(data: any) {
    const info = await selectCompetitorFilter();

    const filterCond = info ? { ...info, ...data } : data;

    addFilterSetting({
      filter_cond: JSON.stringify(filterCond),
      filter_name: 'CompareFilterDifferent',
      uid: gameInfo.edition_unified_id,
      uid_type: gameInfo.id_type,
      business_type: 2,
    });
    console.log(info);
  }

  return { selectCompetitorFilter, addCompetitorFilter };
}
